'use client'

import Image from 'next/image'

import {
  getHeaderBannerUrl,
  type NewsWithBannerFields
} from '../../../utils/newsCtaFields'
import S from './ArticleHeaderBanner.module.scss'

type ArticleHeaderBannerProps = {
  news?: NewsWithBannerFields
}

const ArticleHeaderBanner = ({ news }: ArticleHeaderBannerProps) => {
  const banner = getHeaderBannerUrl(news)

  if (!banner) {
    return null
  }

  return (
    <div className={S.banner} aria-hidden>
      <div className={S.inner}>
        <Image
          src={banner}
          alt=""
          fill
          sizes="100vw"
          className={S.image}
          priority
        />
      </div>
    </div>
  )
}

export default ArticleHeaderBanner
